import React, { useEffect, useRef, useState } from "react";

import { ActionButton, Container, InputDate, Text } from "@jds/core";

// Local
import useInput from "../../../hooks/use-input";
import useApiHttp from "../../../hooks/use-http";
import {
  convertDateFormat,
  convertJDSDateFormat,
  todayDate,
} from "../../../util/helper";

export default function RescheduleEventForm(props) {
  const { closeModal, close, eventDetails, setSuccessModal } = props;
  const [startDateChange, setStartDateChange] = useState(false);
  const [endDateChange, setEndDateChange] = useState(false);
  const {
    value: startDate,
    isValid: startDateIsValid,
    hasError: startDateHasError,
    valueChangeHandler: startDateChangeHandler,
    inputBlurHandler: startDateBlurHandler,
    reset: resetStartDateInput,
  } = useInput(
    (data) => {
      const date = new Date(data);
      if (Object.prototype.toString.call(date) === "[object Date]") {
        if (isNaN(date.getTime())) {
          return false;
        } else {
          return true;
        }
      }
    },
    {
      type: "text",
      value: eventDetails.startDate,
    }
  );

  const {
    value: endDate,
    isValid: endDateIsValid,
    hasError: endDateHasError,
    valueChangeHandler: endDateChangeHandler,
    inputBlurHandler: endDateBlurHandler,
    reset: resetEndDateInput,
  } = useInput(
    (data) => {
      const date = new Date(data);
      if (Object.prototype.toString.call(date) === "[object Date]") {
        if (isNaN(date.getTime())) {
          return false;
        } else {
          return true;
        }
      }
    },
    {
      type: "text",
      value: eventDetails.endDate,
    }
  );

  const { sendRequest: updateEvent, isLoading: eventUpdateing } = useApiHttp();

  const formSubmitHandler = async (e) => {
    startDateBlurHandler(startDate);
    endDateBlurHandler(endDate);
    if (startDateIsValid && endDateIsValid) {
      updateEvent(
        {
          url: "event/reschedule-event",
          method: "POST",
          body: {
            id: eventDetails.id,
            newStartDate: startDateChange
              ? convertDateFormat(startDate)
              : startDate,
            newEndDate: endDateChange ? convertDateFormat(endDate) : endDate,
          },
        },
        (data) => {
          if (data?.statusCode === 200) {
            setSuccessModal();
            closeModal();
          }
        }
      );
    }
  };
  return (
    <form action="" className="column-form fullwidth" onSubmit={(e) => {}}>
      <Container direction="row" gap={4}>
        <Text text="Event Name:" appearance="body-m" />
        <Text text={`${eventDetails.name}`} appearance="body-m-bold" />
      </Container>

      <InputDate
        label="Event start date"
        // helperText="Helper text"
        name="start-date"
        datePicker={true}
        onChange={(value) => {
          startDateChangeHandler({ target: { value } });
          setStartDateChange(true);
        }}
        error={startDateHasError}
        errorText="Please enter the valid date"
        value={startDate}
        min={todayDate()}
      />
      <InputDate
        label="Event end date"
        // helperText="Helper text"
        name="end-date"
        datePicker={true}
        onChange={(value) => {
          endDateChangeHandler({ target: { value } });
          setEndDateChange(true);
        }}
        error={endDateHasError}
        errorText="Please enter the valid date"
        value={endDate}
        min={convertJDSDateFormat(startDate)}
      />

      <Container
        fullWidth
        horizontalAlign="center"
        style={{ marginTop: "16px" }}
      >
        <ActionButton
          label="Reschedule Event"
          onClick={() => {
            formSubmitHandler();
          }}
          disabled={eventUpdateing}
          state={eventUpdateing ? "loading" : "default"}
        />
      </Container>
    </form>
  );
}
